import { IResetPasswordState, ResetPasswordResult } from 'src/contracts/IResetPasswordState';
import { userConstants } from '../constants'
import { ILocalizedError } from 'src/i18n/error-localization';

const initialState: IResetPasswordState = {
    error: null,
    isLoading: false,
    result: undefined
}

export const resetPasswordReducer = (state: IResetPasswordState = initialState, action: any): IResetPasswordState => {
    switch(action.type) {
        case userConstants.RESET_PASSWORD_REQUEST:
           return handleRequest(state)
        case userConstants.RESET_PASSWORD_SUCCESS:
            return handleSuccess(state)
        case userConstants.RESET_PASSWORD_FAILURE:
            return handleFailure(state, action.payload)
    }

    return state
}

const handleRequest = (state: IResetPasswordState): IResetPasswordState => {
    const newState = Object.assign({}, state)
    newState.result = undefined
    newState.error = null
    newState.isLoading = true

    return newState
}

const handleSuccess = (state: IResetPasswordState): IResetPasswordState => {
    const newState = Object.assign({}, state)
    newState.result = ResetPasswordResult.Success
    newState.error = null
    newState.isLoading = false

    return newState
}

const handleFailure = (
    state: IResetPasswordState, 
    payload: {result: ResetPasswordResult, error: ILocalizedError}): IResetPasswordState => 
    {
        const newState = Object.assign({}, state)
        newState.result = payload.result
        newState.error = payload.error
        newState.isLoading = false

        return newState
}


// WEBPACK FOOTER //
// ./src/reducers/reset_password.reducer.ts